import { faCheck } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import { toast } from "react-toastify";
import { DataResult } from "@progress/kendo-data-query";
import axios from "axios";
import StyledPageMenuIcon from "../../../../Layout/PageMenu/PageMenuIcon";
import { DATA_ITEM_KEY } from "../../../../Grid/GridConstants";
import { combinedUrls } from "../../../../URL/functions";
import { validationBacklogUrls } from "../../../../URL/ApplicationUrls";
import PageHeaderButton from "../../../../Layout/Header/PageHeaderButton";
import { PdsrValidationItem } from "../PdsrValidationItem";
import { isItemValid, itemAlreadyExists } from "../ValidateItems";

type Props = {
  readonly dataResult: DataResult;
  readonly setDataResult: (dataResult: DataResult) => void;
  readonly selectedIdsList: Array<number>;
  readonly deselectAll: () => void;
  disabled: boolean;
};

export default function ApproveItemsButton({
  dataResult,
  setDataResult,
  selectedIdsList,
  deselectAll,
  disabled,
}: Props) {
  const selectedItemsList: Array<PdsrValidationItem> = dataResult.data.filter((item) =>
    selectedIdsList.includes(item[DATA_ITEM_KEY])
  );

  const approveItemsWithValidation = async (selectedItems: Array<PdsrValidationItem>) => {
    const validAndNonExistingResults = await Promise.all(
      selectedItems.map(async (it) => {
        const isValid = isItemValid(it);
        if (!isValid) {
          return false;
        }
        const alreadyExists = await itemAlreadyExists(it);
        return !alreadyExists;
      })
    );
    const validItems = selectedItems.filter((_, index) => validAndNonExistingResults[index]);
    if (validItems.length === 0) {
      toast("No valid items to approve", {
        type: "warning",
      });
    } else {
      approveItems(validItems.map((it) => it.Id));
    }
  };

  const approveItems = (itemIds: number[]) => {
    const approvalUrl = combinedUrls(validationBacklogUrls.pdsrs.apiUrl, "Approve");
    const data = { Ids: itemIds };

    axios
      .post(approvalUrl, data)
      .then((response) => response.data)
      .then(() => {
        const result = dataResult.data.filter((item) => {
          return !selectedIdsList.includes(item[DATA_ITEM_KEY]);
        });

        setDataResult({
          data: result,
          total: dataResult.total - selectedIdsList.length,
        });

        deselectAll();

        toast("Validation item was successfully approved", {
          type: "success",
        });
      })
      .catch(() => {
        toast("Error while approving the validation item", {
          type: "error",
        });
      });
  };

  return (
    <PageHeaderButton
      onClick={() => approveItemsWithValidation(selectedItemsList)}
      disabled={disabled || selectedIdsList.length === 0}
    >
      <StyledPageMenuIcon icon={faCheck} />
      Approve
    </PageHeaderButton>
  );
}
